export default __webpack_public_path__ + "static/papper-cloud-crmbg-00aa0df5cbaad331559ec6cf1f13d120.png";